<!--<h1>{{IsShowDetail}}</h1>-->
<form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
  <div *ngIf='IsShowDetail'>
    <div class="row card-deck">
      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form">
        <!--<div class="modal-header">
          <h4 class="modal-title">Identifications</h4>
          <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>-->
        <div class="card-header wh-header">
          My  Identifications
          <button type="button" class="close" data-dismiss="modal"
                  (click)="activeModal.dismiss('Cross click')"
                  aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <!--<form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">-->
        <div class="modal-body">
          <!-- Form actions layout section start -->
          <section id="form-action-layouts">


            <div class="row justify-content-md-center">
              <div class="col-md-12">
                <div class="card">

                  <div class="card-body">
                    <div class="px-3">



                      <div class="form-body">
                        <div class="row">
                          <div class="form-group col-12 mb-2">
                            <label for="eventInput1">Identification Type <span>*</span></label>

                            <!--<CodeTypeValue CodeType="CRTYP" id="CurrentActorIdentitiesRequest.CredentialType" [(ngModel)]="CurrentActorIdentitiesRequest.CredentialType" name="CurrentActorIdentitiesRequest.CredentialType" required></CodeTypeValue>-->
                            <CustomDataByRequestType RequestedType="CredentialTypeByGroup" CustomType="ActorIdentities" id="CurrentActorIdentitiesRequest.CredentialTypeCode"
                                                     [(ngModel)]="CurrentActorIdentitiesRequest.CredentialTypeCode" name="CurrentActorIdentitiesRequest.CredentialTypeCode" required
                                                     (keyChange)="onCredentialTypeByGroup($event)" #CredentialTypeCode="ngModel">
                            </CustomDataByRequestType>
                            <small class="form-text text-danger"
                                   *ngIf="(!CredentialTypeCode.valid && (CredentialTypeCode.dirty || CredentialTypeCode.touched) && CredentialTypeCode.errors.required )">(Field cannot be left blank)</small>

                          </div>
                        </div>

                        <div class="row">
                          <div class="form-group col-12 mb-2">
                            <label for="eventInput2">Identification Number<span>*</span></label>
                            <input type="text" class="form-control" id="CurrentActorIdentitiesRequest.CredentialNumber"
                                   [(ngModel)]="CurrentActorIdentitiesRequest.CredentialNumber" #ProfileTitle="ngModel" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                   name="CurrentActorIdentitiesRequest.CredentialNumber"
                                   placeholder="Identification Number" required maxlength="20" minlength="1" #CredentialNumber="ngModel">
                            <small class="form-text text-danger"
                                   *ngIf="(!CredentialNumber.valid && (CredentialNumber.dirty || CredentialNumber.touched) && CredentialNumber.errors.required )">(Field cannot be left blank)</small>
                            <small class="form-text text-danger"
                                   *ngIf="(!CredentialNumber.valid && CredentialNumber.errors.pattern)">(special characters are not allowed)</small>
                          </div>
                        </div>



                        <!--<div class="row">
                          <div class="form-group col-12 mb-2">
                            <label for="eventInput4">Valid From</label>
                            <input type="date" class="form-control" id="CurrentActorIdentitiesRequest.ValidFrom" [(ngModel)]="CurrentActorIdentitiesRequest.ValidFrom" name="CurrentActorIdentitiesRequest.ValidFrom" placeholder="ValidFrom" required>
                          </div>
                        </div>-->

                        <div class="row">
                          <div class="form-group col-12 mb-2">
                            <label for="eventInput5">Valid Till<span>*</span></label>
                            <!--<input type="date" class="form-control" id="CurrentActorIdentitiesRequest.ValidTo" [(ngModel)]="CurrentActorIdentitiesRequest.ValidTo" name="CurrentActorIdentitiesRequest.ValidTo" placeholder="ValidTo" required>-->
                            <div class="date-form">
                              <input class="form-control" placeholder="Valid Till" [minDate]="minDate" [maxDate]="maxDate"
                                     name="dp1" [(ngModel)]="ValidTo" ngbDatepicker #d1="ngbDatepicker" required>

                              <a (click)="d1.toggle()" class="nav-link-hand">
                                <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                              </a>


                            </div>
                            <!--<div *ngIf="CanAdjustgetTimezoneOffset">
                              <input [owlDateTimeTrigger]="ValidTo" class="form-control" [owlDateTime]="ValidTo"
                                     [max]="MaxDateV" [min]="MinDateV"
                                     id="CurrentActorIdentitiesRequest.ValidTo"
                                     placeholder="Expiring Date"
                                     [(ngModel)]="CurrentActorIdentitiesRequest.ValidTo"
                                     name="CurrentActorIdentitiesRequest.ValidTo">
                              <owl-date-time [pickerType]="'calendar'" #ValidTo></owl-date-time>
                            </div>-->
                            <div *ngIf="CanAdjustgetTimezoneOffset">
                              <!--<ngb-datepicker #dp [(ngModel)]="CurrentActorIdentitiesRequest.ValidTo"  [maxDate]="MaxDateV" [minDate]="MinDateV"
                              id="CurrentActorIdentitiesRequest.ValidTo"
                                     name="CurrentActorIdentitiesRequest.ValidTo"
                                      placeholder="Expiring Date"
                                     ></ngb-datepicker>-->
                              <!--<input class="form-control" placeholder="Expiring Date"
                                     [(ngModel)]="CurrentActorIdentitiesRequest.ValidTo"  [maxDate]="MaxDateV" [minDate]="MinDateV"
                                      id="CurrentActorIdentitiesRequest.ValidTo"  name="CurrentActorIdentitiesRequest.ValidTo"
                                     ngbDatepicker #d="ngbDatepicker">
                              <div class="input-group-append">
                                <button class="btn btn-outline-secondary" (click)="d.toggle()" type="button">
                                  X
                                </button>
                              </div>-->
                            </div>

                          </div>
                        </div>
                        <div class="row">
                          <div class="form-group col-12 mb-2">
                            <label for="eventInput5">Issuing Authority <span>*</span></label>

                            <CodeTypeValue CodeType="ISAUT" id="CurrentActorIdentitiesRequest.IssuingAuthority"
                                           [(ngModel)]="CurrentActorIdentitiesRequest.IssuingAuthority"
                                           name="CurrentActorIdentitiesRequest.IssuingAuthority" #IssuingAuthority="ngModel"
                                           required></CodeTypeValue>
                            <small class="form-text text-danger"
                                   *ngIf="(!IssuingAuthority.valid && (IssuingAuthority.dirty || IssuingAuthority.touched) && IssuingAuthority.errors.required )">(Field cannot be left blank)</small>

                          </div>
                        </div>
                        <!--<div class="row">
                          <div class="form-group col-12 mb-2">
                            <label for="eventInput5">Additional Details </label>
                            <input type="text" class="form-control"
                                   id="CurrentActorIdentitiesRequest.AdditionalDetails"
                                   [(ngModel)]="CurrentActorIdentitiesRequest.AdditionalDetails"
                                   name="CurrentActorIdentitiesRequest.AdditionalDetails"
                                   placeholder="Additional Details" maxlength="100">
                          </div>
                        </div>-->
                        <!--<div class="row">
                          <div class="form-group col-12 mb-2">
                            <label for="eventInput5">Remarks</label>
                            <input type="text" class="form-control" id="CurrentActorIdentitiesRequest.Remarks" [(ngModel)]="CurrentActorIdentitiesRequest.Remarks" name="CurrentActorIdentitiesRequest.Remarks" placeholder="Remarks" required>
                          </div>
                        </div>-->
                        <!--<div class="form-group">
                          <div class="col-md-12">
                            <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn btn-pink btn-block btn-raised">Submit</button>

                          </div>
                        </div>-->


                      </div>



                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <!-- // Form actions layout section end -->
        </div>


        <div class="modal-footer">
          <!--<button type="button" class="btn btn-secondary btn-raised" (click)="activeModal.close('Close click')">Close</button>-->
          <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn btn-primary modal-button-center" id="m-last">Submit</button>

        </div>

      </div>
    </div>
  </div>
  <div *ngIf='IsShowDl'>
    <div class="row card-deck">
      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form">

        <h4 class="card-header wh-header">
          Driver License
          <button type="button" class="close float-right" aria-label="Close"
                  (click)="activeModal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
          </button>
        </h4>

        <div class="modal-body">
          <!-- Form actions layout section start -->
          <section id="form-action-layouts">


            <div class="row justify-content-md-center">
              <div class="col-md-12">
                <div class="card">

                  <div class="card-body">
                    <div class="px-3">
                      <div class="row">
                        <div class="form-group col-12 mb-2">
                          <label for="eventInput2"> License Number<span>*</span></label>
                          <input type="text" class="form-control" id="CurrentActorIdentitiesRequest.CredentialNumber"
                                 [(ngModel)]="CurrentActorIdentitiesRequest.CredentialNumber" #ProfileTitle="ngModel" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                 name="CurrentActorIdentitiesRequest.CredentialNumber"
                                 placeholder="License Number" required maxlength="20" minlength="1" #CredentialNumber="ngModel">
                          <small class="form-text text-danger"
                                 *ngIf="(!CredentialNumber.valid && (CredentialNumber.dirty || CredentialNumber.touched) && CredentialNumber.errors.required )">(Field cannot be left blank)</small>
                          <small class="form-text text-danger"
                                 *ngIf="(!CredentialNumber.valid && CredentialNumber.errors.pattern)">(special characters are not allowed)</small>
                        </div>
                      </div>
                      <div class="row">
                        <div class="form-group col-12 mb-2">
                          <label for="eventInput5">Valid From<span>*</span></label>
                          <!--<input type="date" class="form-control" id="CurrentActorIdentitiesRequest.ValidTo" [(ngModel)]="CurrentActorIdentitiesRequest.ValidTo" name="CurrentActorIdentitiesRequest.ValidTo" placeholder="ValidTo" required>-->
                          <div class="date-form">
                            <input class="form-control" placeholder="Valid From" [minDate]="minDate"
                                   [maxDate]="maxDate"
                                   name="dp1" [(ngModel)]="ValidFrom"
                                   ngbDatepicker #d1="ngbDatepicker" required>

                            <a (click)="d1.toggle()" class="nav-link-hand">
                              <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                            </a>


                          </div>

                        </div>
                      </div>
                      <div class="row">
                        <div class="form-group col-12 mb-2">
                          <label for="eventInput5">Valid To<span>*</span></label>
                          <!--<input type="date" class="form-control" id="CurrentActorIdentitiesRequest.ValidTo" [(ngModel)]="CurrentActorIdentitiesRequest.ValidTo" name="CurrentActorIdentitiesRequest.ValidTo" placeholder="ValidTo" required>-->

                          <div class="date-form">
                            <input class="form-control" placeholder="Valid To" [minDate]="minDate" [maxDate]="maxDate"
                                   name="dp" [(ngModel)]="ValidTo" ngbDatepicker #d="ngbDatepicker">

                            <a (click)="d.toggle()" class="nav-link-hand">
                              <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                            </a>

                          </div>
                          <!--<div class="date-form">
                            <input class="form-control" placeholder="Valid To" [minDate]="minDate" [maxDate]="maxDate"
                                   name="dp2" [(ngModel)]="CurrentActorIdentitiesRequest.ValidTo" ngbDatepicker #d2="ngbDatepicker" required>

                            <a (click)="d2.toggle()" class="nav-link-hand">
                              <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                            </a>


                          </div>-->

                        </div>
                      </div>
                      <div class="row">
                        <div class="form-group col-12 mb-2">

                          <label for="eventInput5">Issuing Authority <span>*</span></label>

                          <CodeTypeValue CodeType="STATE" id="CurrentActorIdentitiesRequest.IssuingAuthority"
                                         [(ngModel)]="CurrentActorIdentitiesRequest.IssuingAuthority"
                                         name="CurrentActorIdentitiesRequest.IssuingAuthority" SelectedValue="{{CurrentActorIdentitiesRequest.IssuingAuthority}}" #IssuingAuthority="ngModel"
                                         required></CodeTypeValue>
                          <!--<CodeTypeValue CodeType="INSTY" id="CurrentActorEditEducationInfoRequest.InstituteType"
                                         [(ngModel)]="CurrentActorEditEducationInfoRequest.InstituteType"
                                         name="CurrentActorEditEducationInfoRequest.InstituteType" SelectedValue="{{CurrentActorEditEducationInfoRequest.InstituteType}}"></CodeTypeValue>-->
                          <small class="form-text text-danger"
                                 *ngIf="(!IssuingAuthority.valid && (IssuingAuthority.dirty || IssuingAuthority.touched) && IssuingAuthority.errors.required )">(Field cannot be left blank)</small>

                        </div>
                      </div>

                      <div class="row">
                        <div class="form-group col-12 mb-2">
                          <label for="eventInput2"> Additional Details :</label>
                          <input type="text" class="form-control"
                                 id="CurrentActorIdentitiesRequest.AdditionalDetails"
                                 [(ngModel)]="CurrentActorIdentitiesRequest.AdditionalDetails"
                                 name="CurrentActorIdentitiesRequest.AdditionalDetails"
                                 placeholder="Additional Details" maxlength="100">
                        </div>
                      </div>


                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <!-- // Form actions layout section end -->
        </div>


        <div class="modal-footer">
          <button (click)="activeModal.close('Close click')" *ngIf='!isRequesting' class="btn actions-btn-prime nav-link-hand button-Schedule actions-btn-prime3 margin-left-auto">Cancel</button>
          <!--<button type="button" class="btn actions-btn-prime close-button margin-right-auto" (click)="activeModal.close('Close click')">Save</button>-->
          <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting'
                  class="btn actions-btn-prime close-button margin-right-auto">
            Save
          </button>

        </div>
      </div>
    </div>

  </div>

  <div *ngIf='IsShowPassport'>
    <div class="row card-deck">
      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form">

        <h4 class="card-header wh-header">
          Passport
          <button type="button" class="close float-right" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
          </button>
        </h4>

        <div class="modal-body">
          <!-- Form actions layout section start -->
          <section id="form-action-layouts">


            <div class="row justify-content-md-center">
              <div class="col-md-12">
                <div class="card">

                  <div class="card-body">
                    <div class="px-3">
                      <!--<detail-grid *ngIf="CurrentActorIdentitiesControllerByCode"
                                   [columns]="dcolumns" [data]="CurrentActorIdentitiesControllerByCode">

                      </detail-grid>-->
                      <!--<div class="row">
                        <div class="form-group col-12 mb-2">
                          <label for="eventInput2"> Identity Type :</label> {{CurrentActorIdentitiesControllerByCode.CredentialType}}

                        </div>
                      </div>-->

                      <div class="row">
                        <div class="form-group col-12 mb-2">
                          <label for="eventInput2"> Passport Number :</label>
                          <input type="text" class="form-control" id="CurrentActorIdentitiesRequest.CredentialNumber"
                                 [(ngModel)]="CurrentActorIdentitiesRequest.CredentialNumber" #ProfileTitle="ngModel" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                 name="CurrentActorIdentitiesRequest.CredentialNumber"
                                 placeholder="Passport Number" required maxlength="20" minlength="1" #CredentialNumber="ngModel">
                          <small class="form-text text-danger"
                                 *ngIf="(!CredentialNumber.valid && (CredentialNumber.dirty || CredentialNumber.touched) && CredentialNumber.errors.required )">(Field cannot be left blank)</small>
                          <small class="form-text text-danger"
                                 *ngIf="(!CredentialNumber.valid && CredentialNumber.errors.pattern)">(special characters are not allowed)</small>
                        </div>
                      </div>
                      <div class="row">
                        <div class="form-group col-12 mb-2">
                          <label for="eventInput5">Valid From<span>*</span></label>
                          <!--<input type="date" class="form-control" id="CurrentActorIdentitiesRequest.ValidTo" [(ngModel)]="CurrentActorIdentitiesRequest.ValidTo" name="CurrentActorIdentitiesRequest.ValidTo" placeholder="ValidTo" required>-->
                          <div class="date-form">
                            <input class="form-control" placeholder="Valid From" [minDate]="minDate"
                                   [maxDate]="maxDate"
                                   name="dp1" [(ngModel)]="ValidFrom"
                                   ngbDatepicker #d1="ngbDatepicker" required>

                            <a (click)="d1.toggle()" class="nav-link-hand">
                              <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                            </a>


                          </div>

                        </div>
                      </div>

                      <div class="row">
                        <div class="form-group col-12 mb-2">
                          <label for="eventInput5">Valid To<span>*</span></label>
                          <!--<input type="date" class="form-control" id="CurrentActorIdentitiesRequest.ValidTo" [(ngModel)]="CurrentActorIdentitiesRequest.ValidTo" name="CurrentActorIdentitiesRequest.ValidTo" placeholder="ValidTo" required>-->
                          <div class="date-form">
                            <input class="form-control" placeholder="Valid To" [minDate]="minDate" [maxDate]="maxDate"
                                   name="dp2" [(ngModel)]="ValidTo" ngbDatepicker #d2="ngbDatepicker" required>

                            <a (click)="d2.toggle()" class="nav-link-hand">
                              <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                            </a>


                          </div>

                        </div>
                      </div>
                      <div class="row">
                        <div class="form-group col-12 mb-2">

                          <label for="eventInput5">Issuing Authority <span>*</span></label>

                          <CodeTypeValue CodeType="ISAUT" id="CurrentActorIdentitiesRequest.IssuingAuthority"
                                         [(ngModel)]="CurrentActorIdentitiesRequest.IssuingAuthority"
                                         name="CurrentActorIdentitiesRequest.IssuingAuthority" SelectedValue="{{CurrentActorIdentitiesRequest.IssuingAuthority}}" #IssuingAuthority="ngModel"
                                         required></CodeTypeValue>
                          <small class="form-text text-danger"
                                 *ngIf="(!IssuingAuthority.valid && (IssuingAuthority.dirty || IssuingAuthority.touched) && IssuingAuthority.errors.required )">(Field cannot be left blank)</small>

                        </div>
                      </div>

                      <div class="row">
                        <div class="form-group col-12 mb-2">
                          <label for="eventInput2"> Additional Details :</label>
                          <input type="text" class="form-control"
                                 id="CurrentActorIdentitiesRequest.AdditionalDetails"
                                 [(ngModel)]="CurrentActorIdentitiesRequest.AdditionalDetails"
                                 name="CurrentActorIdentitiesRequest.AdditionalDetails"
                                 placeholder="Additional Details" maxlength="100">
                        </div>
                      </div>


                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <!-- // Form actions layout section end -->
        </div>


        <div class="modal-footer">
          <button (click)="activeModal.close('Close click')" *ngIf='!isRequesting' class="btn actions-btn-prime nav-link-hand button-Schedule actions-btn-prime3 margin-left-auto">Cancel</button>
          <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting'
                  class="btn actions-btn-prime close-button margin-right-auto">
            Save
          </button>
        </div>
      </div>
    </div>

  </div>
</form>
